import {
  drawerMiniWidth,
  transition,
  containerFluid,
  dangerColor,
  whiteColor,
  warningColor,
  hexToRgb
} from "assets/jss/material-dashboard-pro-react.js";

import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.js";

const appStyle = theme => ({
  ...buttonStyle,
  wrapper: {
    // position: "relative",
    // top: "0",
    // height: "100vh"
    // "&:after": {
    //   display: "table",
    //   clear: "both",
    //   content: '" "'
    // }
  },
  sidebarContainer: {
    position: "fixed",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 5000
  },
  title: {
    fontFamily: "'Archivo Narrow', sans-serif",
    fontSize: "20px",
    color: "#555555",
    fontWeight: "bold"
  },
  card: {
    paddingLeft: "10px",
    paddingRight: "10px",
    height: "40px"
  },
  span: {
    lineHeight: "40px",
    fontSize: "15px",
    fontFamily: "'Archivo Narrow', sans-serif"
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      //width: `calc(100% - ${drawerWidth}px)`,
      width: "100%",
      transitionProperty: "top, bottom, width",
      transitionDuration: ".2s, .2s, .35s",
      transitionTimingFunction: "linear, linear, ease",
      overflow: "auto",
      position: "relative",
      float: "right",
      ...transition,
      maxHeight: "100%",
      overflowScrolling: "touch"
    },
    width: "100%"
  },
  content: {
    //marginTop: "30px",
    [theme.breakpoints.down("md")]: {
      //minHeight: "calc(100vh - 123px)",
     //padding: "30px 15px"
      // paddingTop: "68px"
    }
  },
  container: { ...containerFluid },
  map: {
    marginTop: "70px"
  },
  mainPanelSidebarMini: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerMiniWidth}px)`
    }
  },
  mainPanelWithPerfectScrollbar: {
    overflow: "hidden !important"
  },
  managerClasses: {
    [theme.breakpoints.up("md")]: {
      // display: "inline-block",
      display: "flex",
      lineHeight: "44px"
    }
  },
  notifications: {
    zIndex: "4",
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      top: "5px",
      border: "1px solid " + whiteColor,
      right: "5px",
      fontSize: "9px",
      background: dangerColor[0],
      color: whiteColor,
      minWidth: "16px",
      height: "16px",
      borderRadius: "10px",
      textAlign: "center",
      lineHeight: "14px",
      verticalAlign: "middle",
      display: "block"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "11px",
      marginRight: "2px",
      border: "1px solid " + whiteColor,
      background: warningColor[0],
      color: whiteColor,
      width: "20px",
      height: "20px",
      borderRadius: "10px",
      textAlign: "center",
      display: "inline-block"
      //   lineHeight: "20px"
    }
  },
  transparentStyle: {
    backgroundColor: "transparent",
    paddingTop: "20px"
  },
  linkCart: {
    color: "rgba(" + hexToRgb(warningColor[0]) + ", 0.7)",
    display: "flex",
    "&:hover": {
      color: "rgba(" + hexToRgb(warningColor[0]) + ", 0.7)"
    },
    lineHeight: "initial"
  },
  containerNavCart: {
    fontFamily: "'Archivo Narrow', sans-serif",
    margin: "5px 5px",
    width: "initial",
    [theme.breakpoints.down("sm")]: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      margin: 0
    }
  },
  cartName: {
    paddingLeft: "10px",
    paddingRight: "10px",
    lineHeight: "40px",
    fontSize: "15px",
    fontFamily: "'Archivo Narrow', sans-serif",
    color: "rgba(0,0,0,0.87)"
  },
  containerAlert: {
    display: "block",
    marginTop: "0px",
    top: "10%",
    padding: 0,
    fontSize: 0, // h2 title remove,
    [theme.breakpoints.up("md")]: {
      top: "20%"
    }
  },
  containerAlertBody: {
    overflowY: "auto",
    maxHeight: "calc(100vh - 300px)",
    width: "100%",
    fontSize: "15px",
    padding: "15px",
    paddingBottom: "0px",
    color: "rgba(0,0,0,0.87)"
  }
});

export default appStyle;
